import Locale from './Locale';
import en_US from "./en_US"; // import en_US from "./en_US"

export default Locale;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-locale/src/index.js